import classes from './CopyIcon.module.css';

interface ICopyIconProps {
    width?: number;
    height?: number;
}

const CopyIcon: React.FC<ICopyIconProps> = ({ width = 22, height = 22 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height={width} width={height} viewBox="0 0 48 48" className={classes.icon}>
            <path d="M16 28h24V4H16v24Zm-8 8h24V12H8v24Z" />
        </svg>
    );
};

export default CopyIcon;
